import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpErrorService } from '@web/common';
import { once } from '@web/utils';
import {
  AlertsComponent,
  AlertsService,
  SpinnerFilledComponent,
} from '@web/shared/ui';
import { AdminInvoiceDataSourceService } from '../../services/admin-invoice-data-source.service';
import { AdminInvoiceSettingsFormData } from '../../models/admin-invoice-settings-form-data';
import { AdminInvoiceSettingsFormComponent } from '../admin-invoice-settings-form/admin-invoice-settings-form.component';

@Component({
  selector: 'app-admin-invoice-settings',
  imports: [
    CommonModule,
    AlertsComponent,
    SpinnerFilledComponent,
    AdminInvoiceSettingsFormComponent,
  ],
  templateUrl: './admin-invoice-settings.component.html',
  styleUrl: './admin-invoice-settings.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AlertsService],
})
export class AdminInvoiceSettingsComponent implements OnInit {
  private readonly invoiceDataSource = inject(AdminInvoiceDataSourceService);
  private readonly httpError = inject(HttpErrorService);
  private readonly alerts = inject(AlertsService);

  protected data$!: Observable<AdminInvoiceSettingsFormData>;

  public ngOnInit(): void {
    this.data$ = this.invoiceDataSource.fetchSettingsFormData();
  }

  public handleSubmitClick(data: AdminInvoiceSettingsFormData): void {
    this.invoiceDataSource
      .updateSettingsByFormData(data)
      .pipe(once())
      .subscribe({
        error: (response) => this.showFailureAlertByResponse(response),
      });
  }

  private showFailureAlertByResponse(response: HttpErrorResponse): void {
    this.alerts.showMultiple((builder) =>
      this.httpError
        .extract(response)
        .messages()
        .map((message) => builder.buildFailure(message)),
    );
  }
}
